import clsx from 'clsx';

import { Grid, type GridProps } from '@commons/containers/Grid';

import styles from './index.module.scss';

/**
 * GridSectionContentRegion component.
 */

const GridSectionContentRegion = (props: GridProps) => {
  const { children, className, ref, ...rest } = props;

  const classes = clsx(styles.grid, className);

  return (
    <Grid ref={ref} className={classes} {...rest}>
      {children}
    </Grid>
  );
};

export default GridSectionContentRegion;
